import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import LoginView from './views/LoginView.vue'
import TodayView from './views/TodayView.vue'
import PracticeView from './views/PracticeView.vue'
import CoursesView from './views/CoursesView.vue'
import UnitView from './views/UnitView.vue'
import GardenView from './views/GardenView.vue'
import ProfileView from './views/ProfileView.vue'
import StoryView from './views/StoryView.vue'
import AdminView from './views/AdminView.vue'
import CasesView from './views/CasesView.vue'
import GrammarView from './views/GrammarView.vue'
import WelcomeView from './views/WelcomeView.vue'
import InsightsView from './views/InsightsView.vue'
import WordFamiliesView from './views/WordFamiliesView.vue'
import WordFamilyPracticeView from './views/WordFamilyPracticeView.vue'
import { loadExperience, loadSession, session } from './state'
import { initGermanSpeech } from './speech'
import './styles.css'

initGermanSpeech()

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: LoginView, meta: { public: true } },
    { path: '/welcome', component: WelcomeView },
    { path: '/', component: TodayView },
    { path: '/practice', component: PracticeView },
    { path: '/textbook', component: CoursesView },
    { path: '/cases', component: CasesView },
    { path: '/grammar', component: GrammarView },
    { path: '/word-families', component: WordFamiliesView },
    { path: '/word-families/:id', component: WordFamiliesView },
    { path: '/word-family-practice/:attemptId', component: WordFamilyPracticeView },
    { path: '/units/:id', component: UnitView },
    { path: '/garden', component: GardenView },
    { path: '/story', component: StoryView },
    { path: '/me', component: ProfileView },
    { path: '/insights', component: InsightsView },
    { path: '/admin', component: AdminView, meta: { admin: true } },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  if (!session.ready) await loadSession()
  if (!to.meta.public && !session.user) return '/login'
  if (to.path === '/login' && session.user) return '/'
  if (session.user && !session.user.onboarding_complete && to.path !== '/welcome') return '/welcome'
  if (session.user?.onboarding_complete && to.path === '/welcome' && to.query.replay !== '1') return '/'
  if (to.meta.admin && session.user?.role !== 'admin') return '/'
  if (session.user?.onboarding_complete) await loadExperience()
})

createApp(App).use(router).mount('#app')

if ('serviceWorker' in navigator && import.meta.env.PROD) window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'))
